import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommArrowRightIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.4697 6.46967C14.7626 6.17678 15.2374 6.17678 15.5303 6.46967L19.8232 10.7626C19.8313 10.7706 19.8394 10.7788 19.8476 10.7869C19.9927 10.9319 20.1496 11.0887 20.2642 11.2388C20.3984 11.4148 20.5429 11.6665 20.5429 12C20.5429 12.3335 20.3984 12.5852 20.2642 12.7612C20.1496 12.9113 19.9927 13.0681 19.8476 13.2131C19.8394 13.2212 19.8313 13.2294 19.8232 13.2374L15.5303 17.5303C15.2374 17.8232 14.7626 17.8232 14.4697 17.5303C14.1768 17.2374 14.1768 16.7626 14.4697 16.4697L18.7626 12.1768C18.8326 12.1067 18.8894 12.0499 18.9377 12C18.8894 11.9501 18.8326 11.8933 18.7626 11.8232L14.4697 7.53033C14.1768 7.23744 14.1768 6.76256 14.4697 6.46967Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M20 12C20 12.4142 19.6642 12.75 19.25 12.75L3.75 12.75C3.33579 12.75 3 12.4142 3 12C3 11.5858 3.33579 11.25 3.75 11.25L19.25 11.25C19.6642 11.25 20 11.5858 20 12Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
